import { FormattedMessage, injectIntl } from "react-intl";
import { allowMultiLanguage } from "@nxsys/constants/AppConst";
import PropTypes from "prop-types";

export const InjectMassage = (props: any) => {
  if (allowMultiLanguage) {
    return <FormattedMessage {...props} />;
  } else {
    return props.id.split(".").pop();
  }
};

InjectMassage.propTypes = {
  id: PropTypes.string,
};

const IntlMessages = injectIntl(InjectMassage, {
  forwardRef: false,
});

export default IntlMessages;
